import {
  Box,
  TextField,
  Button,
  Paper,
  Typography,
  Stack,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const API_BASE_URL = "https://localhost:44354/api/admin/reset-password";
const ResetPasswordPage = () => {
  //const [username,setUsername]=useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const passwordsMatch = newPassword === confirmPassword;
  const Location = useLocation();
  const username = Location.state?.username || "";

  useEffect(() => {
    if (!username) {
      alert("Unauthorized access!");
      navigate("/", { replace: true });
    }
  }, [username, navigate]);
  const handleReset = async () => {
    if (username === "") {
      alert("username not exsisits");
      return;
    }
    if (newPassword !== confirmPassword) {
      alert("Password do not match");
      return;
    }
    try {
      const response = await fetch(API_BASE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, newPassword }),
      });
      if (response.ok) {
        alert("Password reset successful!");
        navigate("/");
      } else {
        const err = await response.text();
        alert("Error:" + err);
      }
    } catch (error) {
      alert("Something went Wrong.");
    }
  };
  return (
    <Box
      height="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ backgroundColor: "#f4f4f4" }}
    >
      <Paper elevation={3} sx={{ padding: 4, width: 350 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Reset Password
        </Typography>
        <Stack spacing={2}>
          <TextField
            label="New Password"
            type={showPassword ? "text" : "password"}
            fullWidth
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            error={newPassword.length > 0 && newPassword.length < 8}
            helperText={
              newPassword.length > 0 && newPassword.length < 8
                ? "Password must be at least 8 characters"
                : ""
            }
          />
          <TextField
            label="Confirm Password"
            type={showPassword ? "text" : "password"}
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            error={!passwordsMatch && confirmPassword.length > 0}
            helperText={
              !passwordsMatch && confirmPassword.length > 0
                ? "Passwords do not match"
                : ""
            }
          />
          <Button
            variant="contained"
            fullWidth
            sx={{ backgroundColor: "#007bff" }}
            onClick={handleReset}
          >
            Reset Password
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};
export default ResetPasswordPage;
